import store from '@/store'

/**
 * Validaciones de soft permissions para el usuario actual
 * @param {Array<String>} permissions - Lista de Códigos de privilegios
 * @returns {Object} - Permisos del usuario
 */
export const checkSoftPermissions = permissions => {
  const userPrivileges = getCurrentUserPrivileges()
  const privilegesCode = userPrivileges.map(up => up?.codigo_privilegio)

  const userPermissions = {}
  for (const p in permissions) {
    userPermissions[p] = permissions[p].some(priv => {
      // "permissions" es un array de strings
      if (typeof priv === 'string') {
        return privilegesCode.includes(priv)
      } else {
        // "permissions" es un array de objetos
        return privilegesCode.includes(priv?.codigo_privilegio)
      }
    }) || !permissions[p].length
  }
  return userPermissions
}

/**
 * Obtenemos los permisos del usuario actual
 * @returns {Array} - Los permisos del usuario logueado
 */
export const getCurrentUserPrivileges = () => {
  return store.getters['session/userPrivileges']
}
/**
 * Obtenemos el Rol del usuario actual
 * @returns {String} - El Rol del usuario logueado
 */
export const getCurrentUserRole = () => {
  return store.getters['session/userRole']
}
